import { CircularProgress } from '@alterdomus-analytics/dna-ui/dist/v/1.3.3';
import { Box } from '@mui/material';

export const FullscreenCircularProgress = () => {
  return (
    <Box position="fixed" top="50%" left="50%" sx={{ transform: 'translate(-50%, -50%)' }}>
      <CircularProgress size="large" />
    </Box>
  );
};
